import React, {useState} from "react";
import {
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Tooltip
} from "@material-ui/core";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import zxcvbn from 'zxcvbn';

const NewPasswordField = ({id, name, label, password, error, helperText, exclusions=[], onChange, onBlur}) => {
    const [state, setState] = useState({showPassword: true})

    const handlePasswordChange = (e) => {
        // Calculate the score on what the password will be
        const result = zxcvbn(e.target.value, exclusions);
        // update the parent
        onChange(e, {
            score:  result.score,
            rating: rating(result.score),
            warning: result.feedback.warning,
            suggestions: result.feedback.suggestions
        });
    }

    const handleClickShowPassword = (e) => {
        setState({...state, showPassword: !state.showPassword});
    }

    const handleMouseDownPassword = (e) => {
        e.preventDefault();
    }

    const rating = (score) => {
        switch (score) {
            case 0:  return 'Awful'
            case 1:  return 'Weak'
            case 2:  return 'OK'
            case 3:  return 'Good'
            case 4:  return 'Strong'
            default: return 'Weak'
        }
    }

    return (
        <FormControl
            variant="outlined"
            error={error}
            required={true}
        >
            <InputLabel htmlFor={id || name || "newPassword"}>{label || "New Password"}</InputLabel>
            <OutlinedInput
                id={id || name || "newPassword"}
                name={name || id || "newPassword"}
                label={label || "New Password"}
                type={state.showPassword ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
                onBlur={onBlur}
                variant="outlined"
                required={true}
                fullWidth
                endAdornment={
                    <InputAdornment position="end">
                        <Tooltip title={"Show / Hide password"}>
                            <IconButton
                                aria-label="toggle password visibility"

                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {state.showPassword ? <VisibilityOff/> : <Visibility/> }
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                }
            />
            <FormHelperText id={(id || name || "newPassword")+"HelperText"}>{helperText}</FormHelperText>
        </FormControl>
    )
}

export default NewPasswordField;